import React from "react";
import PropTypes from "prop-types";
import { default as ReactSelect } from "react-select/async";
import axios from 'axios';

const SelectExtendedAsync = props => {
  const loadOptions = (inputValue) => {
    return axios.get(props.url + '?input_value=' + inputValue).then((res) => {
      const loadedOptions = res.data.data.map((item) => {
        return {value: item.id, label: item.name}
      });

      return loadedOptions;
    });
  };

  const handleNoOptionsMessage = inputValue => {
    if (inputValue.length === 0) {
      return 'start typing...'
    }
    else {
      return 'no options'
    }
  }

  if (props.allowSelectAll) {
    return (
      <ReactSelect
        {...props}
        loadOptions={loadOptions}
        noOptionsMessage={({inputValue}) => handleNoOptionsMessage(inputValue)}
      />
    );
  }

  return <ReactSelect {...props} />;
};

SelectExtendedAsync.propTypes = {
  url: PropTypes.string
};

export default SelectExtendedAsync;
